type ApprovalTodoViewInput = {
  isRevisor: boolean;
  isAuditorAssistant: boolean;
  nonRestrictedEquity: number;
  maxAllowedDividend: number;
  isAuditCompleted: boolean;
  isCustomerApprovedAtLeastOnce: boolean;
};

// Auditor assistants have no Revisor relation, but approve as the auditor, so they get the auditor's version too.
export const approvalTodoView = (input: ApprovalTodoViewInput) => {
  const isAuditorView = input.isRevisor || input.isAuditorAssistant;

  return {
    isAuditorView,
    enableDividend: input.nonRestrictedEquity > 0 && input.maxAllowedDividend >= 0 && !isAuditorView,
    approveDisabled: isAuditorView && (!input.isAuditCompleted || !input.isCustomerApprovedAtLeastOnce),
  };
};
